import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import type { ReactNode } from "react";
import * as styles from "../../set-return-locations.module.css";

interface RateSourceSelectionCardProps {
  children: ReactNode;
  title: string;
}

export function RateSourceSelectionCard({
  children,
  title,
}: RateSourceSelectionCardProps) {
  return (
    <Flex className={styles.locationCard} dir="column" gap="md">
      <Text fontSize="sm" fontWeight="semibold">
        {title}
      </Text>
      {children}
    </Flex>
  );
}
